import * as React from "react"
import type { SVGProps } from "react"
const SvgCloudCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.33 14.98-1.4-1.4a1 1 0 0 0-.7-.3q-.4 0-.7.3t-.3.71.3.72l2.12 2.15q.3.3.7.3t.7-.3l4.22-4.23q.3-.3.3-.72 0-.43-.3-.73t-.72-.3c-.42 0-.53.1-.73.3zM6.5 20.86a5.4 5.4 0 0 1-3.89-1.58A5.2 5.2 0 0 1 1 15.43q0-1.95 1.18-3.47c1.17-1.52 1.8-1.67 3.07-1.95a6.8 6.8 0 0 1 2.5-3.73A7 7 0 0 1 12 4.86q2.92 0 4.96 2.03A6.8 6.8 0 0 1 19 11.86q1.72.2 2.86 1.49a4.4 4.4 0 0 1 1.14 3q0 1.89-1.31 3.2c-1.31 1.3-1.94 1.3-3.19 1.3zm0-2h12q1.05 0 1.78-.73.72-.72.72-1.77c0-1.05-.24-1.3-.72-1.78a2.4 2.4 0 0 0-1.78-.72H17v-2q0-2.08-1.46-3.54Q14.07 6.86 12 6.86c-2.07 0-2.56.48-3.54 1.46A4.8 4.8 0 0 0 7 11.86h-.5q-1.46 0-2.47 1.02A3.4 3.4 0 0 0 3 15.36q0 1.45 1.02 2.47a3.4 3.4 0 0 0 2.48 1.03" />
  </svg>
)
export default SvgCloudCheck
